import { RequestOptions } from "axios-types";
import { ApiEndpoints } from "configs";
import { IGetAllTasksQuery, IGetAllTasksResponse, IRetryTaskResponse } from "types/task";
import ExecuteAsync from "utils/api-client";
import createQueryParams from "utils/create-query-params";

const executeGetAllTasksRequest = (
    query: IGetAllTasksQuery,
    options?: RequestOptions,
): Promise<IGetAllTasksResponse | undefined> => {
    // Mirrors schedules.api.ts: the envelope carries pagination fields (total, nextStartKey, ...)
    // as siblings of `data`, which ExecuteAsync's default unwrap (response.data.data) would drop,
    // so this request opts out via `skipEnvelopeUnwrap` and consumes the envelope as-is.
    return ExecuteAsync<undefined, IGetAllTasksResponse>({
        baseURL: ApiEndpoints.BaseUrlEndpoint,
        method: "GET",
        url: `/admin/tasks${createQueryParams(query)}`,
        signal: options?.signal,
        disableNotification: options?.disableNotification,
        skipEnvelopeUnwrap: true,
    });
};

export const executeRetryTaskRequest = (
    taskId: string,
    options?: RequestOptions,
): Promise<IRetryTaskResponse | undefined> =>
    ExecuteAsync<undefined, IRetryTaskResponse>({
        baseURL: ApiEndpoints.BaseUrlEndpoint,
        method: "POST",
        url: `/admin/tasks/${taskId}/retry`,
        signal: options?.signal,
        disableNotification: options?.disableNotification,
    });

export default executeGetAllTasksRequest;
